import { motion } from "framer-motion";

// Different bird silhouette shapes (subtle variation)
const BIRD_PATHS = [
  "M 2 8 Q 6 3, 12 6 Q 18 3, 22 8",
  "M 2 7 Q 6 4, 12 6 Q 18 4, 22 7",
  "M 2 9 Q 6 2, 12 7 Q 18 2, 22 9",
];

// Bird flock configuration — varied positions, sizes, speeds
const BIRDS = [
  { id: 1, top: "16%", size: 22, duration: 38, delay: 0,  direction: 1,  path: 0, opacity: 0.55 },
  { id: 2, top: "24%", size: 16, duration: 44, delay: 6,  direction: 1,  path: 1, opacity: 0.45 },
  { id: 3, top: "20%", size: 28, duration: 42, delay: 14, direction: -1, path: 2, opacity: 0.5  },
  { id: 4, top: "30%", size: 14, duration: 50, delay: 22, direction: 1,  path: 0, opacity: 0.4  },
  { id: 5, top: "18%", size: 18, duration: 46, delay: 30, direction: -1, path: 1, opacity: 0.5  },
];

export default function FlyingBirds() {
  return (
    <div
      className="fixed inset-0 z-[2] pointer-events-none overflow-hidden"
      aria-hidden
    >
      {BIRDS.map((bird) => (
        <motion.div
          key={bird.id}
          className="absolute"
          style={{ top: bird.top }}
          initial={{
            x: bird.direction === 1 ? "-10vw" : "110vw",
          }}
          animate={{
            x: bird.direction === 1 ? "110vw" : "-10vw",
            y: [0, -6, 3, -2, 0],
          }}
          transition={{
            x: {
              duration: bird.duration,
              delay: bird.delay,
              repeat: Infinity,
              repeatDelay: 8,
              ease: "linear",
            },
            y: {
              duration: 6,
              repeat: Infinity,
              ease: "easeInOut",
            },
          }}
        >
          <svg
            width={bird.size}
            height={bird.size * 0.5}
            viewBox="0 0 24 12"
            style={{
              transform: bird.direction === -1 ? "scaleX(-1)" : "none",
              opacity: bird.opacity,
            }}
          >
            <path
              d={BIRD_PATHS[bird.path]}
              stroke="#1a0d1d"
              strokeWidth="1.5"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </motion.div>
      ))}
    </div>
  );
}